import { connect } from 'react-redux'

import { personsEndUsersTableChange } from '../../actions'

const mapStateToProps = (state, hocProps) => ({
    data: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'endUsers',
        'data',
    ]),
    isLoading: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'endUsers',
        'isLoading',
    ]),
    pagination: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'endUsers',
        'pagination',
    ]),
    sorted: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'endUsers',
        'sorted',
    ]),
    filter: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'endUsers',
        'filter',
    ]),
})

export default connect(mapStateToProps, { personsEndUsersTableChange })
